import { XhrFactory } from '@angular/common';
import { Injectable } from '@angular/core';
import { ignoreUntrustedXhrCompletionEvents } from './ignore-untrusted-xhr-events';

/** Browser XHR that ignores Cookiebot's early synthetic completion events. */
@Injectable()
export class TrustedXhrFactory extends XhrFactory {
  build(): XMLHttpRequest {
    const xhr = new XMLHttpRequest();
    ignoreUntrustedXhrCompletionEvents(xhr);
    if (xhr.upload) {
      ignoreUntrustedXhrCompletionEvents(xhr.upload);
    }
    return xhr;
  }
}
